export default __webpack_public_path__ + "static/media/slide-down.f7ad3a90.png";